import AcceptRejectChartDashlet from './AcceptRejectChartDashlet';

export default AcceptRejectChartDashlet;
